export default ($window) => {
    const filter = (seconds) => {
        const days = $window.Math.floor(seconds / 86400);
        const hours = $window.Math.floor((seconds % 86400) / 3600);
        const mins = $window.Math.floor(((seconds % 86400) % 3600) / 60);
        const secs = ((seconds % 86400) % 3600) % 60;

        const daysString = days > 0 ? `${days}d ` : '';
        const hoursString = `00${hours}`.slice(-2);
        const minutesString = `00${mins}`.slice(-2);
        const secondsString = `00${secs}`.slice(-2);

        return `${daysString}${hoursString}:${minutesString}:${secondsString}`;
    };

    filter.$stateful = true;

    return filter;
};



// WEBPACK FOOTER //
// ./src/app/filters/secondsToDateTime/index.js